// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ProgrammingArrowsIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ProgrammingArrows/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.442 13.417c0-.025.016-.05.016-.084V5.417a2.29 2.29 0 0 0-2.291-2.292h-3.275l1.175-.975a.632.632 0 0 0 .083-.883.632.632 0 0 0-.883-.084l-2.5 2.084a.634.634 0 0 0 0 .967l2.5 2.083c.116.1.258.141.4.141a.624.624 0 0 0 .4-1.108l-1.175-.975h3.275c.575 0 1.041.467 1.041 1.042v7.916c0 .034.017.059.017.084a2.501 2.501 0 0 0-1.892 2.416c0 1.384 1.117 2.5 2.5 2.5 1.384 0 2.5-1.116 2.5-2.5a2.501 2.501 0 0 0-1.891-2.416ZM11.233 15.767l-2.5-2.084a.624.624 0 0 0-.883.084.624.624 0 0 0 .083.883l1.175.975H5.833a1.042 1.042 0 0 1-1.041-1.042V6.667c0-.034-.017-.059-.017-.084a2.501 2.501 0 0 0 1.892-2.416c0-1.384-1.117-2.5-2.5-2.5a2.497 2.497 0 0 0-2.5 2.5c0 1.166.808 2.141 1.891 2.416 0 .025-.016.05-.016.084v7.916a2.29 2.29 0 0 0 2.291 2.292h3.275l-1.175.975a.632.632 0 0 0-.083.883c.125.15.3.225.483.225.142 0 .284-.05.4-.141l2.5-2.084a.634.634 0 0 0 0-.967Z"
}));
export default ProgrammingArrowsIcon;